import ReactJS, { useRef, useEffect, useState, useMemo } from "react";
import { notification, Popconfirm } from "antd";
import { Button } from "antd";
import AxiosAPI from "../scripts/AxiosAPI";

interface DataType {
  key: string;
  name: string;
  points: any;
  action: any;
}

type DataIndex = keyof DataType;

function DisableButtonRewardItem({onDeleteItem, item, disable}:any) {
  const [selectedItem, setSelectedItem] = useState({
    id: 0,
    name: "",
    points: 0,
  });

  const [confirmDeleteOpened, setConfirmDeleteOpened] = useState(false);
  const [confirmDeleteLoading, setConfirmDeleteLoading] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const handleDeleteOk = () => {
    setConfirmDeleteLoading(true);

    const _data:any = item;
    
    _data.enabled = !item.enabled;

    AxiosAPI.delRewardsItem(item.id)
      .then((res: any) => {
        console.log(res.data);
        setConfirmDeleteOpened(false);
        setConfirmDeleteLoading(false);
        api.info({
          message: `Completed`,
          description: `${item.name} has been deleted successfully!`,
          placement: `topRight`,
        });
        onDeleteItem(item)
      })
      .catch(() => {});
  };

  const handleDeleteCancel = () => {
    console.log("Clicked cancel button");
    setConfirmDeleteOpened(false);
  };

  const deleteItem = (item: any) => {

    setConfirmDeleteLoading(false);

    setConfirmDeleteOpened(true);

    console.log("deleteThisItem::", item);

  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        title={`${item.enabled?"Disable":"Enable"} ${item.name}`}
        description={`Are you sure you want to ${item.enabled?"disable":"enable"} this reward item?`}
        open={confirmDeleteOpened}
        onConfirm={handleDeleteOk}
        okButtonProps={{ loading: confirmDeleteLoading }}
        onCancel={handleDeleteCancel}
      >
        <Button
          type="default"
          size="large"
          onClick={deleteItem}
        >
          Delete Reward Item
        </Button>
      </Popconfirm>
    </>
  );
}

export default DisableButtonRewardItem;
